import { Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UploadFileDialogComponent } from '../../dialogs/upload-file-dialog/upload-file-dialog.component';
import { DocumentConstants, FormRequiredDocumentsMapping } from 'app/constants/document.constants';
import { FormService } from 'app/services/form.service';
import { AttachmentModel } from 'app/models/attachment.model';

@Component({
  selector: 'app-absence-of-conflict',
  templateUrl: './absence-of-conflict.component.html',
  styleUrls: ['./absence-of-conflict.component.scss']
})
export class AbsenceOfConflictComponent {
  readonly dialog = inject(MatDialog);
  private documentRequired: boolean = false; 

  constructor(protected formService: FormService) {
    this.determineDocumentRequired();
  }

  public openDialog(): void {
    const dialogRef = this.dialog.open(UploadFileDialogComponent, {
          data: { fileName: DocumentConstants.ABSENCE_OF_CONFLICT }
        });
    dialogRef.afterClosed().subscribe();
  }

  get hasAbsenceOfConflictDocument(): boolean {
    return this.formService.doesCurrentFormHaveAttachmentForSection(DocumentConstants.ABSENCE_OF_CONFLICT);
  }

  get attachments(): AttachmentModel[] {
    return this.formService.allAttachmentsForSection(DocumentConstants.ABSENCE_OF_CONFLICT);
  }

  get isDocumentRequired(): boolean {
    return this.documentRequired;
  }
  
  get showRequiredError(): boolean {
    return this.documentRequired && this.formService.isShowingErrorSections && !this.hasAbsenceOfConflictDocument;
  }


  private determineDocumentRequired() {
    this.documentRequired = FormRequiredDocumentsMapping.isDocumentRequiredForForm(this.formService.getCurrentUsanFormType(), DocumentConstants.ABSENCE_OF_CONFLICT);
  }
}
